module.exports = __webpack_public_path__ + "img/img12.d0d02ac0.svg";